import {Network} from "../../../network/Network";
import {ProductType} from "../../../models/product/ProductType";
import {HttpStatus} from "../../../network/status/HttpStatus";
import {WebSocketCommunityEventName} from "../../../network/socket/names/WebSocketCommunityEventName";
import {INetworkComponent} from "../../../network/types/INetworkComponent";
import {arrayRemove} from "../../../sedestral/framework/utilities/ArrayRemove";
import {
    ICommunitySEOPagesTrackingIncoming
} from "../../../models/community/seo/pageTracking/ICommunitySEOPagesTrackingIncoming";
import {IPaginationOutgoing} from "../../../models/pagination/IPaginationOutgoing";
import {
    ICommunitySEOPageTrackingModel
} from "../../../models/community/seo/pageTracking/ICommunitySEOPageTrackingModel";
import {observable} from "@nx-js/observer-util";
import {Services} from "../../Services";
import {ICommunitySEOKeyword} from "../../../models/community/seo/keywords/keyword/ICommunitySEOKeyword";

export class CommunitySeoPageTrackingService {

    public static events: ((pageTracking: ICommunitySEOPageTrackingModel) => void)[] = [];
    public static pages: ICommunitySEOPageTrackingModel[] = observable([]);

    public static dispose(): void {
        this.events = [];
    }

    public static init(): void {
        Network.on(ProductType.COMMUNITY, WebSocketCommunityEventName.COMMUNITY_SEO_PAGE_TRACKING_UPDATE, (pageTracking: ICommunitySEOPageTrackingModel) => {
            pageTracking = this.store(pageTracking);

            this.events.forEach(value => value(pageTracking));
        });
    }

    public static async getPagesTracking(communityId: string, isOpportunity: boolean, paginationOutgoing: IPaginationOutgoing, component?: INetworkComponent): Promise<ICommunitySEOPagesTrackingIncoming> {
        let request = await Network.postJson(ProductType.COMMUNITY, `/community/seo/pageTracking/${communityId}/${isOpportunity ? "true" : "false"}`, paginationOutgoing, component);
        if (request.status == HttpStatus.OK) {
            return this.storePages(request.data);
        }
        return undefined;
    }

    public static async refreshPageTracking(communityId: string, pageTrackingId: string, component?: INetworkComponent): Promise<ICommunitySEOPageTrackingModel> {
        let request = await Network.post(ProductType.COMMUNITY, `/community/seo/pageTracking/refresh/${communityId}/${pageTrackingId}`, {}, component);
        if (request.status == HttpStatus.OK) {
            return this.store(request.data);
        }
    }

    public static async getKeywordsPageTracking(communityId: string, url: string, component?: INetworkComponent): Promise<ICommunitySEOKeyword[]> {
        let request = await Network.post(ProductType.COMMUNITY, `/community/seo/pageTracking/keywords/${communityId}`, { url: url }, component);
        if (request.status == HttpStatus.OK) {
            return request.data;
        }
    }

    static onPageTrackingUpdate(component: INetworkComponent, func: (pageTracking: ICommunitySEOPageTrackingModel) => void) {
        this.events.push(func);
        component.onRemove(() => arrayRemove(this.events, func));
    }

    static storePages(pages: ICommunitySEOPagesTrackingIncoming) {
        pages.pages = pages.pages.map(value => this.store(value));

        return pages;
    }

    static store(page: ICommunitySEOPageTrackingModel) {
        let storedPage = Services.get("id", this.pages, page.id);
        if (storedPage != undefined) {
            storedPage.metrics = page.metrics;
            storedPage.serps = page.serps;
            storedPage.contentRating = page.contentRating;
        }

        return Services.store("id", this.pages, page);
    }
}